import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

// TODO: real types
export interface PostInterface {
  frontmatter: any;
}

export interface PostLinkProps {
  post: PostInterface;
}

const PostLink = ({ post }: PostLinkProps) => {
  const pageContext = post.frontmatter;
  const featuredImage = getImage(pageContext.featuredImage);

  return (
    <div className="py-10 px-5
        border-t-2 border-t-lucid-700 border-r-2 border-r-lucid-900
        shadow-md
        rounded-lg
        bg-gradient-to-l from-lucid-800 to-transparent
        hover:from-lucid-700
      "
    >
      <Link to={pageContext.slug}>
        <div className="
            flex flex-col
            gap-5 justify-center items-center
            md:flex-row
          "
        >
          <div className="bg-lucid-900 p-5 rounded-lg">
            {featuredImage ?
              <div className="aspect-w-4 aspect-h-3 w-64">
                <GatsbyImage
                  className="aspect-content object-cover rounded-md"
                  image={featuredImage}
                  alt={`Picture for ${pageContext.title}`}
                />
              </div>
              : <div className="w-64 h-48 aspect-w-4 aspect-h-3 rounded-md bg-lucid-200 md:mt-1"></div>}
          </div>
          <div className="text-left">
            <h3 className="h3 pb-2 text-lg">{pageContext.title}</h3>
            <p className="text-lucid-300 text-sm">{pageContext.description}</p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default PostLink;
